import { SxProps } from "@mui/system";

export const RegisterIPStyle: Record<string, SxProps> = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: "20px",
    maxWidth: "800px",
    margin: "0 auto",
  },
  card: {
    padding: 3,
    borderRadius: 2,
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  },
  dropZone: {
    border: "2px dashed #1976d2",
    borderRadius: 2,
    padding: 4,
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: "#f5f9ff",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#e3f2fd",
    },
  },
  infoAlert: {
    marginBottom: 2,
  }
};
